import React, { useRef, useState, useMemo } from "react";
import { FiCheckCircle, FiCircle } from "react-icons/fi";
import { MdDeleteForever, MdClose, MdAdd, MdImage, MdViewModule, MdBlock, MdCheck, MdSync } from "react-icons/md";
import ShowimagesLoading from "./showImagesLoading";
import PrevviewProFilt from "./prevviewProFilt";
import {
  linkFTP,
  UnlinkFTP,
  linkVFTP,
  UnlinkVFTP,
  AddFormFilProView,
  TextFilProView,
  AddFilImg,
  DeletFilImg,
  FormInputFilProView
} from "../auth/apiProduct";

import "./adfilterProduct.css";
import { elakayAutoText } from "./dataElakay";

// Un vrai id de filtre est toujours un ObjectId Mongo sérialisé (chaîne hex de
// 24 caractères). Nécessaire car buildCustomerDisplayFilters
// (cjProductSyncService.js) fabrique, pour l'aperçu client, des entrées de
// remplacement quand product.filters est vide (`_id: { name, FilterItem }`,
// sans vrai _id) -- editProduct réutilisant ce même endpoint, ces entrées
// synthétiques peuvent apparaître ici aussi. Sans ce garde-fou, filterIdOf
// retombait sur cet objet entier, produisant une URL du type
// ".../AddFormFilProView/<productID>/[object%20Object]" (400 côté serveur).
const isValidFilterId = (value) => typeof value === "string" && /^[a-f0-9]{24}$/i.test(value);
const filterIdOf = (item) => {
  const id = item?._id?._id ?? item?._id;
  return isValidFilterId(id) ? id : undefined;
};

const AddFilterProduct = (props) => {
  const {
    laguangeElakay,
    infoSource,
    ImagesProd = [],
    filterSel = [],
    filters = [],
    token,
    catID,
    loadProductsView,
    filtersProduct = [],
    items = {}
  } = props;

  const imageTextDivRef = useRef([]);
  const imageTextDiv = imageTextDivRef.current;

  const [pageFilVal, setPageFilVal] = useState(false);
  const [pageFilNa, setPageFilNa] = useState(true);
  const [images, setImages] = useState("");
  const [textFil, setTextFil] = useState("");
  const [syncingAll, setSyncingAll] = useState(false);

  // Translation helper
  const t = useMemo(() => {
    const langCode = infoSource?.languageAPI || "en";
    
    const get = (section, key, fallback = "") => {
      try {
        return infoSource?.laguangeElakay?.(section, langCode)?.[key] ?? 
               infoSource?.language?.(infoSource, section, key) ?? 
               fallback;
      } catch (e) {
        return fallback;
      }
    };

    return {
      filterItems: get("title", "filterItems") || "Filter Items",
      filterValues: get("title", "FilValprodView") || "Filter Values",
      productFilters: get("title", "FilprodView") || "Product Filters",
      close: get("Button", "close") || "Close",
      square: get("Button", "square") || "Square",
      circle: get("Button", "circle") || "Circle",
      images: get("Button", "images") || "Images",
      none: get("Button", "none") || "None",
      colorCircle: elakayAutoText("h_adfilter_style_color_circle", "Color Circle"),
      colorSquare: elakayAutoText("h_adfilter_style_color_square", "Color Square"),
      productStyle: elakayAutoText("h_adfilter_style_product", "Product Card"),
      allItems: get("label", "allItems") || "All items",
      submit: get("Button", "submit") || "Submit",
      delete: get("Button", "delete") || "Delete",
      allImgItems: get("title", "allImgItems") || "All Image Items",
      syncAll: elakayAutoText("h_adfilter_sync_all_values", "Sync All"),
      syncing: elakayAutoText("h_adfilter_syncing_values", "Syncing..."),
    };
  }, [infoSource]);

  // =========================
  // API ACTIONS
  // =========================
  const handleToggleFilter = (catID, filID, token) => () => {
    linkFTP(catID, filID, token).then((data) => {
      if (data?.error) return;
      if (data?.Success) loadProductsView?.(catID);
    });
  };

  const removeFilter = (catID, filID, token) => {
    UnlinkFTP(catID, filID, token).then((data) => {
      if (data?.error) return;
      loadProductsView?.(catID);
    });
  };

  const handleToggleValue = (catID, filID, name, token) => () => {
    linkVFTP(catID, filID, name, token).then((data) => {
      if (data?.error) return;
      if (data?.Success) loadProductsView?.(catID, filID);
    });
  };

  const removeValue = (catID, filID, name, token) => {
    UnlinkVFTP(catID, filID, name, token).then((data) => {
      if (data?.error) return;
      loadProductsView?.(catID, filID);
    });
  };

  // Sync every not-yet-linked value in one shot (left list -> right list).
  const handleSyncAllValues = (catID, filID, token, valuesToSync) => () => {
    if (!filID || !valuesToSync?.length || syncingAll) return;
    setSyncingAll(true);
    Promise.all(valuesToSync.map((name) => linkVFTP(catID, filID, name, token)))
      .then(() => loadProductsView?.(catID, filID))
      .finally(() => setSyncingAll(false));
  };

  const handleFormSelectDIV = (catID, filID, formInput, token) => {
    if (!filID) return;
    FormInputFilProView(catID, filID, formInput, token).then((data) => {
      if (data?.error) return;
      loadProductsView?.(catID, filID);
    });
  };

  const handleTextFilProView = (catID, filID, textRead, token) => {
    if (!filID) return;
    TextFilProView(catID, filID, textRead, token).then((data) => {
      if (data?.error) return;
      loadProductsView?.(catID, filID);
    });
  };

  const handFormFilProView = (formValueFil) => {
    const filID = filterIdOf(items);
    imageTextDivRef.current = [];

    if (!filID || !formValueFil) return;

    AddFormFilProView(catID, filID, formValueFil, token).then((data) => {
      if (data?.error) return;
      loadProductsView?.(catID, filID);
    });
  };

  const handFilterImage = () => {
    const filID = filterIdOf(items);
    if (!filID) return;

    AddFilImg(catID, filID, imageTextDivRef.current, token).then((data) => {
      if (data?.error) return;
      loadProductsView?.(catID, filID);
    });
  };

  const DelFilterImage = () => {
    const filID = filterIdOf(items);
    if (!filID) return;

    DeletFilImg(catID, filID, imageTextDivRef.current, token).then((data) => {
      if (data?.error) return;
      loadProductsView?.(catID, filID);
    });
  };

  // =========================
  // VIEW LOGIC
  // =========================
  const pageChange = (filId) => {
    loadProductsView?.(catID, filId);
    setPageFilVal(true);
    setPageFilNa(false);
  };

  const pageChangeExit = () => {
    setPageFilVal(false);
    setPageFilNa(true);
  };

  const checkSel = (filId) => {
    return (filterSel || []).some(item => filId === item?._id?._id);
  };

  const checkSelValue = (value) => {
    return (items?.FilterItem || []).some(item => value === item);
  };

  const checkTextImg = (formInput, formValueFil) => {
    if (formInput === false && (formValueFil === "Square" || formValueFil === "Circle")) return true;
    return false;
  };

  const handleChangeText = (value) => {
    setTextFil(textFil ? "" : value);
    imageTextDiv.splice(0, 1, textFil ? "" : value);
  };

  const handleChangeImage = (url) => {
    setImages(images ? "" : url);
    imageTextDiv?.length > 0 
      ? imageTextDiv.splice(1, 1, images ? "" : url)
      : imageTextDiv.push("", images ? "" : url);
  };

  const checkIncludes = (arr, item) => {
    return arr?.some(elem => JSON.stringify(elem) === JSON.stringify(item));
  };

  // =========================
  // UI COMPONENTS
  // =========================

  // Filter Names List (Left side)
  const FilterNamesList = () => (
    <div className="filter-names-section">
      <div className="section-header">
        <h4 className="section-title">{t.filterItems}</h4>
      </div>

      <div className="filters-list-container">
        {filters?.map((c, i) => (
          <div 
            key={i} 
            className={`filter-item ${checkSel(c._id._id) ? 'selected' : ''}`}
          >
            <div className="filter-item-checkbox">
              {checkSel(c._id._id) ? (
                <FiCheckCircle 
                  className="icon-selected" 
                  onClick={handleToggleFilter(catID, c._id._id, token)}
                />
              ) : (
                <FiCircle 
                  className="icon-unselected"
                  onClick={handleToggleFilter(catID, c._id._id, token)}
                />
              )}
            </div>

            <div className="filter-item-content">
              <span className="filter-name">{c._id.name}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // Selected Filters (Right side)
  const SelectedFiltersList = () => (
    <div className="selected-filters-section">
      <div className="section-header">
        <h4 className="section-title">{t.productFilters}</h4>
      </div>

      <div className="filters-list-container">
        {(filterSel || []).map((c, i) => (
          <div 
            key={c?._id?._id || i} 
            className="filter-item"
            onClick={() => pageChange(c?._id?._id)}
          >
            <div className="filter-item-content">
              <span className="filter-name">{c?._id?.name}</span>
            </div>

            <button 
              className="filter-item-delete"
              onClick={(e) => {
                e.stopPropagation();
                removeFilter(catID, c?._id?._id, token);
              }}
            >
              <MdDeleteForever />
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  // Filter Values List (Left side in edit mode)
  const FilterValuesList = () => {
    const filID = filterIdOf(items);
    const allValues = items?._id?.FilterItem || [];
    const selectedValues = items?.FilterItem || [];
    const unsyncedValues = allValues.filter((v) => !selectedValues.includes(v));

    return (
    <div className="filter-values-section">
      <div className="section-header">
        <h4 className="section-title">
          {items?._id?.name || t.filterValues}
        </h4>
        {unsyncedValues.length > 0 && (
          <button
            type="button"
            className="btn-sync-all"
            disabled={syncingAll}
            onClick={handleSyncAllValues(catID, filID, token, unsyncedValues)}
          >
            <MdSync className={syncingAll ? "icon-spin" : ""} />
            {syncingAll ? t.syncing : `${t.syncAll} (${unsyncedValues.length})`}
          </button>
        )}
      </div>

      <div className="filters-list-container">
        {(items?._id?.FilterItem || []).map((c, i) => (
          <div 
            key={i} 
            className={`filter-item ${checkSelValue(c) ? 'selected' : ''}`}
          >
            <div className="filter-item-checkbox">
              {checkSelValue(c) ? (
                <FiCheckCircle 
                  className="icon-selected"
                  onClick={handleToggleValue(catID, filterIdOf(items), c, token)}
                />
              ) : (
                <FiCircle 
                  className="icon-unselected"
                  onClick={handleToggleValue(catID, filterIdOf(items), c, token)}
                />
              )}
            </div>

            <div className="filter-item-content">
              <span className="filter-name">{c}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
    );
  };

  // Selected Values (Right side in edit mode)
  const SelectedValuesList = () => (
    <div className="selected-filters-section">
      <div className="section-header">
        <h4 className="section-title">{t.filterValues}</h4>
      </div>

      <div className="filters-list-container">
        {(items?.FilterItem || []).map((c, i) => (
          <div key={`${c}-${i}`} className="filter-item">
            <div className="filter-item-content">
              <span className="filter-name">{c}</span>
            </div>

            <button 
              className="filter-item-delete"
              onClick={() => removeValue(catID, filterIdOf(items), c, token)}
            >
              <MdDeleteForever />
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  // Display Settings -- redesigné en cartes visuelles (aperçu de forme réel
  // plutôt qu'un <select> natif générique) + toggles segmentés au lieu de
  // radios empilées, pour que le style choisi se voie d'un coup d'œil.
  const STYLE_OPTIONS = [
    { value: "Square", label: t.square, preview: <span className="style-shape style-shape--square" /> },
    { value: "Circle", label: t.circle, preview: <span className="style-shape style-shape--circle" /> },
    { value: "Images", label: t.images, preview: <MdImage /> },
    { value: "Color Circle", label: t.colorCircle, preview: <span className="style-shape style-shape--circle style-shape--color" /> },
    { value: "Color Square", label: t.colorSquare, preview: <span className="style-shape style-shape--square style-shape--color" /> },
    { value: "product", label: t.productStyle, preview: <MdViewModule /> },
    { value: "None", label: t.none, preview: <MdBlock /> },
  ];

  const DisplaySettings = () => (
    <div className="display-settings">
      {/* Style Selector -- en premier et en pleine largeur : c'est le choix
          qui détermine le rendu final chez le client, les deux toggles
          en dessous ne font qu'affiner ce style. */}
      <div className="setting-group setting-group--full">
        <label className="setting-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adfilterProduct.t003}</label>
        <div className="style-picker-grid">
          {STYLE_OPTIONS.map((opt) => {
            const active = (items?.formValueFil || "") === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                className={`style-picker-card ${active ? "active" : ""}`}
                onClick={() => handFormFilProView(opt.value)}
              >
                {active && <MdCheck className="style-picker-check" />}
                <span className="style-picker-preview">{opt.preview}</span>
                <span className="style-picker-label">{opt.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="settings-grid settings-grid--toggles">
        {/* Form Type */}
        <div className="setting-group">
          <label className="setting-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adfilterProduct.t001}</label>
          <div className="segmented-toggle">
            <button
              type="button"
              className={`segmented-toggle-btn ${!items?.formInput ? "active" : ""}`}
              onClick={() => handleFormSelectDIV(catID, filterIdOf(items), false, token)}
            >
              {items?.formValueFil === "Images" ? elakayAutoText("h_7632f1ffb4a6b4", "With Border") : elakayAutoText("h_da55288dd78523", "Form Selected")}
            </button>
            <button
              type="button"
              className={`segmented-toggle-btn ${items?.formInput ? "active" : ""}`}
              onClick={() => handleFormSelectDIV(catID, filterIdOf(items), true, token)}
            >
              {items?.formValueFil === "Images" ? elakayAutoText("h_fe18ddd51c8d25", "Without Border") : elakayAutoText("h_45c0a436a03a13", "Form Div")}
            </button>
          </div>
        </div>

        {/* Text/Image Toggle */}
        <div className="setting-group">
          <label className="setting-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adfilterProduct.t002}</label>
          <div className="segmented-toggle">
            <button
              type="button"
              className={`segmented-toggle-btn ${!!items?.textRead ? "active" : ""}`}
              onClick={() => handleTextFilProView(catID, filterIdOf(items), true, token)}
            >
              {checkTextImg(items?.formInput, items?.formValueFil) ? elakayAutoText("h_784b9c97d2e9a8", "With Image") : elakayAutoText("h_176cc85ebb6438", "With Text")}
            </button>
            <button
              type="button"
              className={`segmented-toggle-btn ${!items?.textRead ? "active" : ""}`}
              onClick={() => handleTextFilProView(catID, filterIdOf(items), false, token)}
            >
              {checkTextImg(items?.formInput, items?.formValueFil) ? elakayAutoText("h_02b7483dbe753c", "Without Image") : elakayAutoText("h_07ef69e5b434e1", "Without Text")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // Image Gallery (for Images mode)
  const ImageGallery = () => (
    <div className="image-gallery-section">
      <div className="section-header">
        <h4 className="section-title">{t.allImgItems}</h4>
      </div>

      <div className="image-grid">
        {ImagesProd?.galeries?.map((nm, i) => (
          <div 
            key={i} 
            className={`image-grid-item ${images === nm.urlImg ? 'selected' : ''}`}
            onClick={() => handleChangeImage(nm.urlImg)}
          >
            <ShowimagesLoading src={nm.urlImg} alt={nm._id} />
          </div>
        ))}
      </div>
    </div>
  );

  // Color/Value Selector with Preview
  const ColorValueSelector = () => {
    const values = items?.FilterItem?.length > 0 
      ? items.FilterItem 
      : items?._id?.FilterItem;
  
    const StyleFil = (value) => {
      if (items?._id?.name === "color") {
        return {
          backgroundColor: value,
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          display: 'inline-block',
          border: '2px solid #e5e7eb'
        };
      }
      return {};
    };

    return (
      <div className="color-value-selector">
        <div className="values-list">
          {values?.map((k, i) => (
            <div 
              key={i} 
              className={`value-item ${textFil === k ? 'selected' : ''}`}
              onClick={() => handleChangeText(k)}
            >
              {items?._id?.name === "color" && (
                <span style={StyleFil(k)} className="color-swatch"></span>
              )}
              <span className="value-name">{k}</span>
            </div>
          ))}
        </div>

        {/* Preview */}
        {imageTextDiv[1] && (
          <div className="preview-card">
            <div className="preview-image-wrapper">
              <ShowimagesLoading 
                src={imageTextDiv[1]} 
                alt={imageTextDiv[0]} 
              />
              {items?.textRead && (
                <div className="preview-label">{imageTextDiv[0]}</div>
              )}
            </div>

            {imageTextDiv[0] && imageTextDiv[1] && (
              <div className="preview-actions">
                {checkIncludes(items?.Images, imageTextDiv) ? (
                  <button 
                    className="btn-danger-modern"
                    onClick={DelFilterImage}
                  >
                    <MdDeleteForever />
                    {t.delete}
                  </button>
                ) : (
                  <button 
                    className="btn-primary-modern"
                    onClick={handFilterImage}
                  >
                    <MdAdd />
                    {t.submit}
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>
  );
}

  // =========================
  // MAIN RENDER
  // =========================
  return (
    <div className="add-filter-product-modern">
      {/* Header */}
      <div className="product-header-modern">
        <h3 className="product-title-modern">{t.productFilters}</h3>
      </div>

      {/* Main Content */}
      <div className="product-content-modern">
        {/* PAGE 1: Filter Names Selection */}
        {pageFilNa && filters?.length > 0 && (
          <div className="filters-grid-modern">
            <FilterNamesList />
            <SelectedFiltersList />
          </div>
        )}

        {/* PAGE 2: Filter Values Edition */}
        {pageFilVal && (
          <div className="filter-edit-section">
            {/* Close Button */}
            <button 
              className="btn-close-modern"
              onClick={pageChangeExit}
            >
              <MdClose />
              {t.close}
            </button>

            {/* Ce filtre n'a pas de vrai _id (voir isValidFilterId ci-dessus)
                -- c'est une entrée de remplacement générée pour l'aperçu
                client (buildCustomerDisplayFilters), pas un filtre réellement
                lié au produit. Aucune configuration de style ne peut être
                sauvegardée tant qu'il n'est pas lié via "Add Filter". */}
            {!filterIdOf(items) && (
              <div className="unlinked-filter-notice">
                {elakayAutoText(
                  "h_adfilter_unlinked_notice",
                  "This filter isn't linked to the product yet -- link it from \"Add Filter\" before changing its display style."
                )}
              </div>
            )}

            {/* Filter Values Grid */}
            <div className="filters-grid-modern">
              <FilterValuesList />
              <SelectedValuesList />
            </div>

            {/* Display Settings */}
            <DisplaySettings />

            {/* Preview Section */}
            <div className="preview-section">
              <div className="section-header">
                <h4 className="section-title">{t.filterValues}</h4>
              </div>

              {items?._id && (
                <PrevviewProFilt
                  infoSource={infoSource}
                  allFilterPro={filtersProduct}
                  filter={[items]}
                  imageTextDiv={imageTextDivRef.current}
                  setImages={setImages}
                  setTextFil={setTextFil}
                  del={true}
                />
              )}
            </div>

            {/* Image Mode Components */}
            {items?.formValueFil === "Images" && items?._id && (
              <>
                <ImageGallery />
                <ColorValueSelector />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddFilterProduct;
